import DetailsForm from "./DetailsForm";

export default DetailsForm;
